<template>
  <div>
    <gmap-map
      ref="gmap"
      :center="center"
      :zoom="12"
      :options="{styles: styles, disableDefaultUI: true}"
    >
    <!--https://github.com/xkjyeah/vue-google-maps/issues/333 dölja default UI med true eller false i options, msv. https://developers.google.com/maps/documentation/javascript/examples/control-disableUI-->

      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="toggleInfoWindow(m,index)"
        :icon="m.icon"
      >
      <!--:icon="m.icon" sätter custom marker-->
      </gmap-marker>

      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen=false"
      >
        <div v-html="infoContent"></div>
      </gmap-info-window>

    </gmap-map>
  </div>
</template>

<script>
// https://teunohooijer.com/tag/vue2-google-maps/

export default {
  name: 'MyGoogleMap',
  data () {
    return {
      // a default center for the map
      center: { lat: 43.772911, lng: 11.249519 },
      map: null,
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      // optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },

      // lägg till json styles här, det är samma som används för snazzy maps, och om man vill använda googles egna "styla din karta" verktyg
      styles: [
        {
          'featureType': 'poi',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        }
      ],
      markers: [
        {
          name: 'Ristorante Pensavo Peggio',
          // description: '', // lägg till mer text
          // date_build: '', // lägg till mer text
          position: { lat: 43.7724, lng: 11.24957 },
          // icon: { url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png' }

          // om man vill använda paths https://stackoverflow.com/questions/7095574/google-maps-api-3-custom-marker-color-for-default-dot-marker
          icon: {
            path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
            //   path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
            scale: 1,
            strokeWeight: 0.2,
            strokeColor: '#05091C',
            strokeOpacity: 1,
            fillColor: '#05091C',
            fillOpacity: 0.85
          }
          // icon: this.pinSymbol('black')
        },
        {
          name: 'Hotel Santa Maria Novella',
          // description: '', // lägg till mer text
          // date_build: '', // lägg till mer text
          position: { lat: 43.773399, lng: 11.25012 },
          // om man vill ha en bildlänk
          // icon: { url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png' }

          icon: {
            path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
            //   path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
            scale: 1,
            strokeWeight: 0.2,
            strokeColor: '#05091C',
            strokeOpacity: 1,
            fillColor: '#05091C',
            fillOpacity: 0.85
          }
        }
      ]
    };
  },
  mounted () {
    // set bounds of the map
    this.$refs.gmap.$mapPromise.then((map) => {
      // eslint-disable-next-line no-undef
      const bounds = new google.maps.LatLngBounds();
      for (let m of this.markers) {
        bounds.extend(m.position);
      }
      map.fitBounds(bounds);
    });

    // vueGoogleMapsInit();
  },
  methods: {
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = this.getInfoWindowContent(marker);


      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      // eslint-disable-next-line brace-style
      }
      // if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    getInfoWindowContent: function (marker) {
      return (`<div class="mygooglemap-card">
        <p>${marker.name}</p>
      </div>`);
    }
    // pinSymbol (color) {
    //   return {
    //     path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
    //     fillColor: color,
    //     fillOpacity: 1,
    //     strokeColor: '#000',
    //     strokeWeight: 2,
    //     scale: 1
    //   };
    // }
  }
};
</script>